import { imageUpload } from './ImageStore';

export const updateImageUpload = (value) => imageUpload.update((oldValue) => value);
